import { Text, TouchableOpacity, View } from 'react-native'
import { Ionicons, AntDesign } from '@expo/vector-icons'

// styles
import { colorPalette, fontPalette, globalStyles } from '../../../static/styles/global'

type IconPosition = 'left' | 'center'
interface customButtonProps {
  text: string
  onPress: any
  isDisabled?: boolean
  color?: string
  reverse?: boolean
  light?: boolean
  icon?: any
  iconPosition?: IconPosition
  transparent?: boolean
}

const CustomButtonThree = ({
  text,
  onPress,
  isDisabled = false,
  color,
  reverse,
  light,
  icon,
  iconPosition,
  transparent
}: customButtonProps): JSX.Element => {
  let btnBgColor: { backgroundColor: string }
  let btnTextColor: { color: string }
  switch (color) {
    case 'primary':
      btnBgColor = reverse
        ? globalStyles.whiteBgColor
        : globalStyles.primaryBgColor
      btnTextColor = reverse
        ? globalStyles.primaryTextColor
        : globalStyles.whiteTextColor
      break

    case 'secondary':
      btnBgColor = reverse
        ? globalStyles.whiteBgColor
        : globalStyles.secondaryBgColor
      btnTextColor = reverse
        ? globalStyles.secondaryTextColor
        : globalStyles.whiteTextColor
      break

    case 'tertiary':
      btnBgColor = reverse
        ? globalStyles.whiteBgColor
        : globalStyles.tertiaryBgColor
      btnTextColor = reverse
        ? globalStyles.tertiaryTextColor
        : globalStyles.whiteTextColor
      break

    case 'dark':
      btnBgColor = reverse
        ? globalStyles.whiteBgColor
        : globalStyles.darkBgColor
      btnTextColor = reverse
        ? globalStyles.darkTextColor
        : globalStyles.whiteTextColor
      break

    case 'gray':
      btnBgColor = reverse
        ? globalStyles.whiteBgColor
        : globalStyles.grayBgColor
      btnTextColor = reverse
        ? globalStyles.grayTextColor
        : globalStyles.whiteTextColor
      break

    case 'lightGray':
      btnBgColor = reverse
        ? globalStyles.whiteBgColor
        : globalStyles.lightGrayBgColor
      btnTextColor = reverse
        ? globalStyles.lightGrayTextColor
        : globalStyles.darkTextColor
      break

    case 'light':
      btnBgColor = reverse
        ? globalStyles.darkBgColor
        : globalStyles.lightBgColor
      btnTextColor = reverse
        ? globalStyles.lightTextColor
        : globalStyles.darkTextColor
      break

    case 'danger':
      btnBgColor = reverse
        ? globalStyles.whiteBgColor
        : globalStyles.dangerBgColor
      btnTextColor = reverse
        ? globalStyles.dangerTextColor
        : globalStyles.whiteTextColor
      break

    case 'success':
      btnBgColor = reverse
        ? globalStyles.whiteBgColor
        : globalStyles.successBgColor
      btnTextColor = reverse
        ? globalStyles.successTextColor
        : globalStyles.whiteTextColor
      break

    case 'warn':
      btnBgColor = reverse
        ? globalStyles.whiteBgColor
        : globalStyles.warnBgColor
      btnTextColor = reverse
        ? globalStyles.warnTextColor
        : globalStyles.whiteTextColor
      break

    case 'black':
      btnBgColor = reverse
        ? globalStyles.whiteBgColor
        : globalStyles.blackBgColor
      btnTextColor = reverse
        ? globalStyles.blackTextColor
        : globalStyles.whiteTextColor
      break

    case 'white':
      btnBgColor = reverse
        ? globalStyles.darkBgColor
        : globalStyles.whiteBgColor
      btnTextColor = reverse
        ? globalStyles.whiteTextColor
        : globalStyles.darkTextColor
      break

    default:
      btnBgColor = reverse
        ? globalStyles.whiteBgColor
        : globalStyles.tertiaryBgColor
      btnTextColor = reverse
        ? globalStyles.tertiaryTextColor
        : globalStyles.whiteTextColor
      break
  }

  return (
    <TouchableOpacity onPress={onPress} disabled={isDisabled}>
      <View
        style={[
            {borderRadius: 10,
                paddingHorizontal: 5,
                paddingVertical: 5,
                height: 25,backgroundColor:'#FFFFFF',borderColor:'#FFFFFF'
            },
          transparent ? globalStyles.transparentBg : btnBgColor,
          isDisabled && globalStyles.buttonDisable
        ]}
      >
        <View
          style={[
            globalStyles.hDirection,
            iconPosition !== 'left' && globalStyles.hCenterItems,
            globalStyles.vCenterItems
          ]}
        >
          {icon && (
            <View style={[globalStyles.mr1,]}>
              <Ionicons name={icon} size={12} color={colorPalette.white} />
            </View>
          )}

          <Text
            style={[
              iconPosition === 'left' && globalStyles.flexOne,
              {fontSize: 10,
                // lineHeight: 19,
                fontFamily: fontPalette.primaryRegular,
                color: colorPalette.dark},
              btnTextColor,
              globalStyles.textCenter,
              light ? globalStyles.fwRegular : globalStyles.fwBold
            ]}
          >
            {text}
          </Text>
        </View>
      </View>
    </TouchableOpacity>
  )
}

export default CustomButtonThree
